module.exports = __webpack_public_path__ + "static/tagging_screen@2x-0aaf56b83ebd14bd978bd149503681ff.png";